import React from "react";
import { ArticlePageType } from "../../types/optimizely/articlePage";
import RTEBlock from "../../components/RTEBlock/RTEBlock";
import ContactPerson from "../../components/ContactPerson/ContactPerson";
import { HeroBlock } from "../../components/HeroBlock/HeroBlock";
import TextAndImageBlock from "../../components/TextAndImageBlock/TextAndImageBlock";
import { ContentArea } from "../../components/ContentArea/ContentArea";
import useMobileView from "../../utils/useMobileView";

interface ArticlePageProps {
  content: ArticlePageType;
}

function formatDate(inputDate: string): string {
  const date = new Date(inputDate);

  // Options for formatting the date to "04. Jun 2024"
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  };

  // Format the date using the specified locale and options
  return date.toLocaleDateString('en-GB', options).replace(/,/g, '');
};

const HeroModule = ({ content }: ArticlePageProps) => {

  const isMobile = useMobileView(770)

  if (content?.mainImage?.expandedValue?.url) {
    return (
      <TextAndImageBlock
        name={content.name}
        rightClasses="pb-14"
        additionalIntro={content.pageTypeDisplayName}
        description={{
          value: content.mainIntro.value,
          propertyDataType: "PropertyXhtmlString",
          contentLink: {
            guidValue: ''
          }
        }}
        title={{
          propertyDataType: "PropertyLongString",
          value: content.name,
          contentLink: null,
        }}
        image={content.mainImage}
        backgroundColor={{
          propertyDataType: "PropertyLongString",
          value: "primaryTurquoise",
        }}
        showImageAsSecond={isMobile}
        overridesForRightClasses={isMobile ? "p-6" : null}
      />)
  } else {
    return (
      <div className="max-w-[836px] mx-auto p-">
        <p className="text-primary md:text-xs text-mob-xs md:mb-8 mb-5"><b>{content.pageTypeDisplayName}</b> {formatDate(content.startPublish)}</p>
        <h1 className="md:text-article-h1 text-mob-article-h1 text-primary mb-8 md:max-w-[80%]">{content.name}</h1>
        <p className="mx-auto md:text-article-subtitle text-mob-article-subtitle text-primary mb-16">{content.mainIntro.value}</p>
      </div>
    )
  };
};


export const ArticlePage: React.FC<ArticlePageProps> = ({ content }) => {
  if (!content) {
    return <></>;
  }

  return (
    <div className="bg-neutralYellow font-sans ">
      {/* Smelly fix
      Client wanted to uniform the whitespace on frontpage and other pages
      There are breadcrumbs on other pages, but not on front page  */}
      <div className="md:min-h-0 lg:min-h-[34px]" />

      <HeroModule content={content} />
      <RTEBlock content={content.mainBody.value} />
      <ContactPerson
        primaryContactPersonsContentArea={content.primaryContactPersonsContentArea.expandedValue?.[0]}
        informationContentAreaRight={content.informationContentAreaRight}
        secondaryContactPersonsContentArea={content.secondaryContactPersonsContentArea.expandedValue?.[0]}
      />
      {content.informationContentAreaBottom.value ?? content.informationContentAreaBottom.expandedValue 
        ? <div className="pt-6"><ContentArea contentArea={content.informationContentAreaBottom} /></div> 
        : null}
    </div>
  );
};
